import { TCustomFieldType } from '@/shared/services/forms/forms.types';

export enum CUSTOM_COLUMNS {
	APPLICANT = 'applicant',
	EMAIL = 'email',
	DATE = 'date',
	MESSAGES = 'messages',
	LABELS = 'labels',
	AI_SHORTLISTING = 'ai_shortlisting',
	FORM_STATUS = 'form_status',
	FORM_LABELS = 'form_labels',
	ASSIGNED_COMMENTS = 'assigned_comments',
	IMPORT = 'import',
	SUBMISSION_FEEDBACK = 'submission_feedback',
	SOURCE = 'source',
	ASSIGNMENTS = 'assignments',
	OFFERS = 'offers',
}

export const CUSTOM_COLUMN_TYPES: Record<CUSTOM_COLUMNS, TCustomFieldType> = {
	[CUSTOM_COLUMNS.APPLICANT]: 'PRE_DEFINED_INPUT_APPLICANT',
	[CUSTOM_COLUMNS.EMAIL]: 'PRE_DEFINED_INPUT_EMAIL',
	[CUSTOM_COLUMNS.DATE]: 'PRE_DEFINED_INPUT_DATE',
	[CUSTOM_COLUMNS.MESSAGES]: 'MESSAGES',
	[CUSTOM_COLUMNS.LABELS]: 'SUBMISSION_LABELS',
	[CUSTOM_COLUMNS.AI_SHORTLISTING]: 'AI_SHORTLISTING',
	[CUSTOM_COLUMNS.FORM_STATUS]: 'FORM_STATUS_COLUMN',
	[CUSTOM_COLUMNS.FORM_LABELS]: 'FORM_LABELS_COLUMN',
	[CUSTOM_COLUMNS.ASSIGNED_COMMENTS]: 'ASSIGNED_COMMENTS',
	[CUSTOM_COLUMNS.IMPORT]: 'PRE_DEFINED_INPUT_IMPORT',
	[CUSTOM_COLUMNS.SUBMISSION_FEEDBACK]: 'SUBMISSION_FEEDBACK',
	[CUSTOM_COLUMNS.SOURCE]: 'SUBMISSION_SOURCE',
	[CUSTOM_COLUMNS.ASSIGNMENTS]: 'ASSIGNMENT_STATUS',
	[CUSTOM_COLUMNS.OFFERS]: 'OFFER_STATUS',
};

/** Column types that persist width/order via `custom_fields`, not `input_fields`. */
export const CUSTOM_FIELD_COLUMN_TYPES: string[] = Object.values(CUSTOM_COLUMN_TYPES);
